module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_TI.c8fa2db6.txt";